import { CMMetricsCarousel, CMPortfolioMetrics } from "./portfolio-metrics.styles";
import Carousel from "../../carousel/carousel.component";
import { SwiperSlide } from "swiper/react";
import MetricItem from "../metric-item/metric-item.component";
import { useEffect, useState } from "react";
import PORTFOLIO_METRICS from "../../../Services/fake/portfolio-metrics";
import { useAuth } from "../../../Contexts/auth.context";
import { getWalletBalance } from "../../../Services/prod/auth.service";
import { formatCommaNumbers } from "../../../Utils/common.utils";
import HelpTooltip from "../../help-tooltip/help-tooltip.component";

const breakpoints= {
    1024: {
      slidesPerView: 3,
    },
    992: {
      slidesPerView: 2,
    },
    1: {
      slidesPerView: 1,
    }
}

export const MoneyFormatted = (data) =>{
  try{
    if(data==undefined||data==''||data==null){
      return '$0.00'
    }
    const dataFormatted = parseFloat(data).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  
    return dataFormatted;
  }catch(error){
    console.error("Formatted Error: ", error)
  }
  
}

const PortfolioMetrics = () => {
  const { auth } = useAuth();
  const [metrics, setMetrics] = useState(PORTFOLIO_METRICS);
  const [loading, setLoading] = useState(true);
  const [update, setUpdate] = useState(false);
  function formatUnitsTrade(num) {
    return num % 1 === 0 ? num.toFixed(0) : num;
}
    
  useEffect(() => {
    const timer = setTimeout(() => {
      getWalletBalance()
        .then(response => {
          const balanceData = response?.data[0];
          const availableCash = balanceData?.available_cash;
          const restrictedCash = balanceData?.restricted_cash;
          const totalCash = balanceData?.total_cash;
          const portfolioValue = balanceData?.portfolioValue;
          const gain  = balanceData?.symbolsValue?.unit_value?.dailyUnrealizedGains;
          const values  = balanceData?.symbolsValue?.unit_value?.value;
          const myValues  = balanceData?.symbolsValue?.issuer_unit_value?.value;
          const dailyGain  = balanceData?.symbolsValue?.issuer_unit_value?.dailyGainsValues;
          const dailyGainPercentage  = balanceData?.symbolsValue?.unit_value?.daily_gains;
          const daily_gains  = balanceData?.symbolsValue?.issuer_unit_value?.daily_gains;
          const available_units  = formatUnitsTrade(+balanceData?.symbolsValue?.issuer_unit_value?.available_units);
          const total_units  = formatUnitsTrade(+balanceData?.symbolsValue?.issuer_unit_value?.total_units);
          const trade_value  = balanceData?.symbolsValue?.issuer_unit_value?.trade_value;

          const unitTrade_value = auth?.user_accounttype === "Rightsholder" ?  balanceData?.symbolsValue?.issuer_unit_value ?.trade_value :  balanceData?.symbolsValue?.unit_value?.trade_value ;
          const unitTrade_units =  auth?.user_accounttype === "Rightsholder" ?  balanceData?.symbolsValue?.issuer_unit_value ?.trade_units :  balanceData?.symbolsValue?.unit_value?.trade_units ; 

          const unitLock_value = auth?.user_accounttype === "Rightsholder" ?  balanceData?.symbolsValue?.issuer_unit_value ?.lock_value :  balanceData?.symbolsValue?.unit_value?.lock_value ;
          const unitLock_units = auth?.user_accounttype === "Rightsholder" ?  balanceData?.symbolsValue?.issuer_unit_value ?.lock_units :  balanceData?.symbolsValue?.unit_value?.lock_units ;
  
          const updatedMetrics = PORTFOLIO_METRICS.map(metric => {
            if (metric.title === 'Cash Balance') {
              return {
                ...metric,
                items: [
                  { title: 'Cash Balance', value: `${MoneyFormatted(totalCash)}`, className: 'dotted-border' },
                  { title: 'Available Cash', value: `${MoneyFormatted(availableCash)}` },
                  { title: 'Restricted Cash', value: `${MoneyFormatted(restrictedCash)}`, tooltipTitle:'Funds set aside to cover your pending buy orders.'},
                ]
              };
            }
            if (metric.title === 'Portfolio Value') {
              const items = [
                { title: "Cash Balance", value:`${MoneyFormatted(totalCash)}`,className: 'dotted-border'},
                { title: "Units Value",  value: `${MoneyFormatted(values)}`,tooltipTitle:'The total value of all units you currently own, based on the latest market price.'},
                ...(auth.user_accounttype && auth.user_accounttype !== 'Trader' ? 
                  [{
                      title:'My Units Value',
                      value: MoneyFormatted(myValues),
                      tooltipTitle:'Value of your remaining units from your listing, based on the latest available price.',
                      // subContent: `${MoneyFormatted(dailyGain)} (${daily_gains}%)`,
                      style: { textAlign: "right" }
                  }] 
                  : []
              ),
              { title: "Daily Gain", value: `${(MoneyFormatted(dailyGain || 0))}` + "(" +  (dailyGainPercentage || 0) + "%" + ")"},
              { portfolioValue:`${MoneyFormatted(portfolioValue)}`},
              ]; 
              return {
                ...metric,
                items
              };
            }
            
            if (metric.title === 'My Units') {
              return {
                ...metric,
                items: [
                  { title: 'My Units', value: "(" + formatCommaNumbers(total_units) + ") " + MoneyFormatted(trade_value), className: 'dotted-border', tooltipTitle:'The number of unsold units you still own from your own auction listing.' },
                  { title: "My units - for Trade", value: "(" + formatCommaNumbers((unitTrade_units || 0)) + ") " +  MoneyFormatted((unitTrade_value || 0))} ,
                  { title: "My units - Restricted", value: "(" + `${formatCommaNumbers(unitLock_units || 0)}` + ")  " +  MoneyFormatted(unitLock_value || 0)},
                ]
              };
            }
            return metric;
          });
  
          setMetrics(updatedMetrics);
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
          console.error("Error fetching wallet balance:", error);
        });
    }, 2000); 
  
    return () => clearTimeout(timer); 
  }, [update]);
  const ButtonClick=()=>{
    setLoading(true)
    setUpdate(!update);
  }

    return (
        <>
        <CMPortfolioMetrics>
        {metrics &&
          metrics && metrics.length > 0 ? (
            metrics.map((metric, index) => {

              if (index === metrics.length - 1 && (!auth.user_accounttype  || auth.user_accounttype === "Trader")) {
                return null; 
              }
              return <MetricItem data={metric} key={index} loading={loading} ButtonClick={ButtonClick}/>;
            })
          ) : (
            ''
          )
        }
             

      </CMPortfolioMetrics>

          <CMMetricsCarousel>
            <Carousel breakpoints={breakpoints} style={{paddingBottom: '3rem'}} >
                {metrics && metrics.length > 0 ?
                  metrics.map((metric, index) => {
                    
                    // This condition hides the 'offline units value' card, for mobile devices.
                    if (index === metrics.length - 1 && (!auth.user_accounttype  || auth.user_accounttype === "Trader")) {
                      return null
                    }
                    // (This condition is temporary.)

                    return (
                        <SwiperSlide key={index}>
                            <MetricItem data={metric} key={index} loading={loading} ButtonClick={ButtonClick}/>
                        </SwiperSlide>
                    );
                  }): ''
                }
            </Carousel>
          </CMMetricsCarousel>
        </>
    );
}

export default PortfolioMetrics;